/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentHeaderDiscountViewModel } from "../types/IndividualPaymentHeaderDiscountViewModel.ts";

export const individualPaymentHeaderDiscountViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  active: z.optional(z.boolean()),
  description: z.string().nullish(),
  discountTypeId: z.optional(z.number().int()),
  percentage: z.optional(z.number()),
  deleteJustification: z.string().nullish(),
  discountTypeText: z.string().nullish(),
  retroactive: z.optional(z.boolean()),
  approved: z.optional(z.boolean()),
}) as unknown as ToZod<IndividualPaymentHeaderDiscountViewModel>;
